import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const settingsApi = createApi({
  reducerPath: 'settings',


  baseQuery: createBaseQueryWithReauth('/settings'),
  tagTypes: ['Settings'],

  endpoints: builder => ({
    getProfile: builder.query({
      query: () => ({
        url: `/profile`,
        method: 'GET',
      }),
      providesTags: ['Settings'],
    }),




    editProfile: builder.mutation({
      query: ({ ...data }) => ({
        url: `/profile`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Settings'],
    }),
     
    
    getCashProfile: builder.query({
      query: () => ({
        url: `/cash-register`,
        method: 'GET',
      }),
      providesTags: ['Cash'],
    }),
    getCashProfile: builder.query({
      query: (shop_id) => {
        const params = {};
        if (shop_id !== undefined) {
          params.shop_id = shop_id;
        }
        return {
          url: '/cash-register',
          method: 'GET',
          params,
        };
      },
      providesTags: ['Cash'],
    }),


    editCashProfile: builder.mutation({
      query: ({ shop_id, ...body }) => ({
        url: `/cash-register${shop_id ? `?shop_id=${shop_id}` : ''}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Cash'],
    }),

  }),
});

export const {
  useGetProfileQuery,

  useEditProfileMutation,
  useGetCashProfileQuery,
useEditCashProfileMutation,
  useBagMutation,
} = settingsApi;
